import { ReactElement } from "react";

interface IProps {
  width?: number;
  height?: number;
  fill?: string;
}

const CyberClashIcon = ({
  width = 15,
  height = 16,
  fill = "white",
}: IProps): ReactElement => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="bonfire 1" clipPath="url(#clip0_835_1129)">
      <g id="Group">
        <g id="Group_2">
          <path
            id="Vector"
            d="M13.3736 13.2035C13.1914 12.8128 12.868 12.5165 12.4629 12.3691L12.2178 12.2799L12.4629 12.1906C12.868 12.0432 13.1914 11.7469 13.3736 11.3562C13.5557 10.9656 13.5749 10.5273 13.4275 10.1223C13.28 9.71723 12.9837 9.39385 12.593 9.21165C12.2024 9.02949 11.7641 9.01036 11.3591 9.15778L10.5548 9.45051C9.75751 10.1922 8.69665 10.6495 7.53362 10.6582L7.49934 10.6583C6.34408 10.6583 5.25386 10.2264 4.41436 9.43955L3.64013 9.15778C3.23501 9.0103 2.79685 9.02946 2.40621 9.21165C2.01556 9.39379 1.7192 9.7172 1.57178 10.1223C1.26741 10.9584 1.70013 11.8863 2.53626 12.1906L2.78135 12.2799L2.53626 12.3691C1.7001 12.6735 1.26744 13.6013 1.57178 14.4374C1.7192 14.8425 2.01556 15.1659 2.40621 15.3481C2.62318 15.4492 2.85477 15.5001 3.08721 15.5001C3.27336 15.5001 3.46004 15.4675 3.64013 15.402L7.49964 13.9972L11.3591 15.402C11.5393 15.4675 11.7259 15.5001 11.912 15.5001C12.1445 15.5001 12.3761 15.4492 12.5931 15.3481C12.9837 15.1659 13.2801 14.8425 13.4275 14.4374C13.5749 14.0324 13.5558 13.5942 13.3736 13.2035ZM3.33905 14.5748C3.15498 14.6418 2.95576 14.6331 2.77816 14.5504C2.60059 14.4676 2.46589 14.3206 2.39888 14.1364C2.26057 13.7564 2.45721 13.3346 2.83728 13.1963C2.91981 13.1662 3.0043 13.152 3.08742 13.152C3.38712 13.152 3.66916 13.3371 3.77745 13.6347C3.91579 14.0147 3.71912 14.4364 3.33905 14.5748ZM12.6003 14.1364C12.5333 14.3205 12.3986 14.4675 12.221 14.5503C12.0434 14.6331 11.8442 14.6418 11.6601 14.5748C11.28 14.4364 11.0834 14.0147 11.2217 13.6346C11.2887 13.4505 11.4234 13.3035 11.601 13.2207C11.6996 13.1748 11.8049 13.1516 11.9106 13.1516C11.9951 13.1516 12.08 13.1664 12.1619 13.1962C12.346 13.2632 12.493 13.3979 12.5758 13.5755C12.6586 13.7531 12.6673 13.9523 12.6003 14.1364Z"
            fill="white"
          />
        </g>
      </g>
      <g id="Group_3">
        <g id="Group_4">
          <path
            id="Vector_2"
            d="M9.74313 2.74355L7.49961 0.5L5.25608 2.74355C4.35878 3.64085 3.86463 4.83388 3.86463 6.10287V6.14298C3.86463 7.11903 4.24616 8.03526 4.93889 8.72288C5.62502 9.40395 6.53331 9.77798 7.49934 9.77798C7.50854 9.77798 7.51786 9.77795 7.52709 9.77789C9.51625 9.76313 11.1346 8.11454 11.1346 6.1029C11.1346 4.83388 10.6404 3.64082 9.74313 2.74355ZM7.50995 8.89773C6.74896 8.90335 6.1303 8.28821 6.1303 7.52854V7.51134C6.1303 7.02138 6.32495 6.55146 6.67141 6.205L7.49955 5.37687L8.32768 6.205C8.67417 6.55146 8.86879 7.02138 8.86879 7.51134C8.86882 8.26632 8.26493 8.89213 7.50995 8.89773Z"
            fill="white"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_835_1129">
        <rect width="15" height="15" fill={fill} transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default CyberClashIcon;
